import React from 'react';

export const OptionalIndicator = () => <HelperText text="optional" />;

export const HelperText = ({ text }: { text: string }) => (
  <small className="form-text text-muted d-block text-right">{text}</small>
);
